<template>
    <section class="section">
        <div class="container">
            <div class="columns">
                <div class="column">
                    <h1 class="title">{{ translate("page.schedule_status.title") }}: {{ scheduleProgress.name }}</h1>

                    <a :href="scheduleListingUrl">
                        <button class="button">
                            <span class="icon">
                                <i class="fa fa-arrow-left"></i>
                            </span>
                            <span>{{ translate("common.go_back_to_list") }}</span>
                        </button>
                    </a>
                </div>
            </div>

            <div class="columns" v-if="initDone">
                <div class="column">
                    <template v-if="scheduleProgress.matStatuses.length">
                        <table class="table is-hoverable is-striped is-fullwidth">
                            <thead>
                                <tr>
                                    <th>{{ translate("page.schedule_status.mat") }}</th>
                                    <th>{{ translate("page.schedule_status.expected_end") }} <sup>*</sup></th>
                                    <th>{{ translate("page.schedule_status.actual_end") }}</th>
                                    <th>{{ translate("page.schedule_status.delay") }}</th>
                                    <th>{{ translate("page.schedule_status.remaining_fights") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="matStatus in scheduleProgress.matStatuses" :key="matStatus.id">
                                    <td>{{ matStatus.name }}</td>
                                    <td>{{ formatDelayHourMinutes(matStatus.expectedEndTime) }}</td>
                                    <td>{{ formatDelayHourMinutes(matStatus.actualEndTime, "HH:mm") }}</td>
                                    <td>
                                        <span :class="getDelayStatus(matStatus.delay)">
                                            {{ formatDelay(matStatus.delay) }}
                                        </span>
                                    </td>
                                    <td>{{ matStatus.totalRemainingFights }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p><sup>*</sup> - {{ translate("page.schedule_status.stored_hours") }}</p>
                    </template>
                    <div class="notification is-warning" v-else>
                        <p class="has-text-weight-bold">
                            {{ translate("page.schedule_status.unavailable.title") }}
                        </p>
                        <p>
                            {{ translate("page.schedule_status.unavailable.description") }}
                        </p>
                        <p class="mt-2">
                            {{ translate("page.schedule_status.unavailable.set_planned_version") }}
                        </p>
                        <p class="mt-2">
                            <a :href="helpCenter().sharingSchedulePlannedVersion()" target="_blank" rel="noopener">
                                {{ translate("page.schedule_status.unavailable.help_link") }}
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="columns" v-else>
                <LoadingSpinner2 class="has-added-margin" />
            </div>
        </div>
    </section>
</template>

<script>
    import requestMixin from "../Common/requestMixin";
    import errorHandlerMixin from "../Common/errorHandlerMixin";
    import timeFormatter from "../Common/timeFormatter";
    import dateTimeUtilsMixin from "../Common/dateTimeUtilsMixin";
    import LoadingSpinner2 from "../Common/LoadingSpinner2.vue";
    import urlsMixin from "../Urls/urlsMixin";

    export default {
        name: "schedule-status-app",
        components: {
            LoadingSpinner2,
        },
        mixins: [requestMixin, errorHandlerMixin, dateTimeUtilsMixin, urlsMixin],
        props: ["getScheduleProgressUrl", "scheduleListingUrl", "eventTimezone", "eventStartDate"],
        data() {
            return {
                scheduleProgress: {
                    name: "...",
                    matStatuses: [],
                },
                initDone: false,
            };
        },
        mounted() {
            return this.fetchScheduleProgress()
                .finally(() => {
                    this.initDone = true;
                })
                .catch(this.handleError);
        },
        methods: {
            fetchScheduleProgress() {
                return this.promiseRequest({
                    url: this.getScheduleProgressUrl,
                    method: "get",
                    json: true,
                }).then(res => {
                    if (res.statusCode !== 200) {
                        throw Error("Could not fetch schedule progress.");
                    }

                    this.scheduleProgress = res.body;
                });
            },
            getDelayStatus(delay) {
                if (delay > 0) {
                    return "tag is-warning";
                } else {
                    return "tag is-success";
                }
            },
            formatDelay(delay) {
                const prettyTime = timeFormatter.formatSecondsToPrettyTime(Math.abs(delay));

                if (delay > 0) {
                    return "+" + prettyTime;
                }
                if (delay < 0) {
                    return "-" + prettyTime;
                }

                return prettyTime;
            },
            formatDelayHourMinutes(dateTime, format = "yyyy-MM-dd HH:mm") {
                const timezoned = this.convertToTimezone(dateTime, this.eventTimezone, format);

                return !!timezoned ? timezoned : "--:--";
            },
        },
    };
</script>

<style scoped>
    .label {
        font-size: 90%;
        font-weight: normal;
    }
</style>
